<template>
	<div class="d-flex w-100">
		<div class="d-flex align-items-center flex-fill">
			<h6
				v-if="isShowTotal"
				class="m-0 typo-body-2"
			>
				{{ totalSelect }} Selected
			</h6>
			<div
				v-if="isShowClear"
				:class="[
					'color-black-45',
					{
						'ml-3 pl-2 clear-action': isShowTotal
					}
				]"
			>
				<button
					:disabled="disabledClear"
					:class="[
						'clear-button typo-body-2 border-0 bg-transparent color-black-45',
						{
							'p-0': !isShowTotal
						}
					]"
					@click="handleClear"
				>
					Clear all selected
				</button>
			</div>
		</div>
		<CButton
			:disabled="disabledCancel"
			color="tertiary"
			class="modal-button transparent mr-3"
			@click="handleCancel"
		>
			Cancel
		</CButton>
		<CButton
			:disabled="disabledComfirm"
			color="primary"
			class="modal-button transparent"
			@click="handleConfirm"
		>
			Done
		</CButton>
	</div>
</template>

<script>
export default {
	name: 'BaseModalFooter',

	props: {
		totalSelect: {
			type: [Number, String],
			default: 0,
		},
		isShowTotal: {
			type: Boolean,
			default: true,
		},
		disabledComfirm: {
			type: Boolean,
			default: false,
		},
		disabledCancel: {
			type: Boolean,
			default: false,
		},
		disabledClear: {
			type: Boolean,
			default: false,
		},
		isShowClear: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		handleClear() {
			this.$emit('onClear');
		},
		handleCancel() {
			this.$emit('onCancel');
		},
		handleConfirm() {
			this.$emit('onConfirm');
		},
	},
};
</script>


<style lang="scss" scoped>
	.clear-action {
		border-left: 1px solid $color-gray-300;

		.clear-button {
			&:focus {
				outline: none;
			}
		}
	}
</style>
